import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { pillRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {pillRoutes.map((prop, key) => {
      if (prop.layout === 'category') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/category" to="/modify-pills" />
  </Switch>
);

const Pills = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Pills;
